import React from 'react';
import PropTypes from 'prop-types';

const ModalHeader = props => (
  <React.Fragment>
    {props.includeHeaderCloseButton &&
      <button
        className="modal-close-btn"
        onClick={props.onClose}
      />
    }
    {props.headingText &&
      <div className={props.modalHeaderClass}>
        <h3 className={props.headingClass}>{props.headingText}</h3>
        {props.subHeadingText ? (
          <p className={props.subHeadingClass}>{props.subHeadingText}</p>
        ) : <div />}
      </div>
    }
  </React.Fragment>
);

ModalHeader.propTypes = {
  modalHeaderClass: PropTypes.string,
  headingText: PropTypes.string,
  headingClass: PropTypes.string,
  subHeadingText: PropTypes.string,
  subHeadingClass: PropTypes.string,
  onClose: PropTypes.func,
  includeHeaderCloseButton: PropTypes.bool,
};

ModalHeader.defaultProps = {
  modalHeaderClass: 'modal-header',
  headingText: '',
  headingClass: '',
  subHeadingText: '',
  subHeadingClass: 'centered',
  includeHeaderCloseButton: false,
  onClose: () => null,
};

export default ModalHeader;



// WEBPACK FOOTER //
// ./src-react/Modals/components/ModalHeader/index.jsx